(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeUserPasswordController', ChangeUserPasswordController);

    ChangeUserPasswordController.$inject = ['API', 'i18n', '$scope',];

    function ChangeUserPasswordController(API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.isSubmitting = false;
        vm.newPassword = '';

        activate();

        function activate() {
            vm.user = $scope.placeholders.user;
        }


        function submit() {
            if (!vm.isSubmitting) {
                vm.isSubmitting = true;
                vm.user.password = vm.newPassword;
                var promise = API.User.changePassword({
                    id: vm.user.id,
                    loginTeacher: {
                        password: vm.newPassword,
                    },
                    loginIusadmin: {
                        password: vm.newPassword,
                    }
                }).$promise;
                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                }, function () {})
                .finally(function() {
                    vm.isSubmitting = false;
                    $scope.$parent.close();
                });
            }
        }

    }
})();